<div class="toolbar-break">
</div>
<div class="container">
  <div class="hero-title d-flex flex-column align-items-start mt-5">
    <h1>Order #{{order?.number}}</h1>
    <div class="mb-3">
      <mat-chip-listbox>
        @if (order?.cancelReason) {
          <mat-chip-option selected selectable="false" color="warn">Canceled</mat-chip-option>
        }
        @if (order?.financialStatus) {
          <mat-chip-option selected selectable="false" [color]="order?.financialStatus?.color">{{order?.financialStatus?.label}}</mat-chip-option>
        }
        <mat-chip-option selected selectable="false" [color]="order?.fulfillmentStatus?.color">{{order?.fulfillmentStatus?.label}}</mat-chip-option>
      </mat-chip-listbox>
      @if (order?.cancelReason) {
        <div class="d-flex flex-column py-3">
          <span>Order was canceled on {{order?.canceledAt | date: 'medium'}}</span>
          <span>Reason: {{order?.cancelReason}}</span>
        </div>
      }
    </div>
  </div>
  <!-- Desktop -->
  <div class="d-none d-lg-block order-box">
    <div class="row p-3">
      <div class="col-1">
        <span>Product</span>
      </div>
      <div class="col-7">
        <span></span>
      </div>
      <div class="col-1 text-end">
        <span>Price</span>
      </div>
      <div class="col-1 text-end">
        <span>Quantity</span>
      </div>
      <div class="col-2 text-end">
        <span>Total</span>
      </div>
    </div>
    <div class="price-border mb-3">
    </div>
    <div class="row gy-3 mb-4 p-3">
      @for (item of order?.items; track item) {
        <div class="col-1">
          <div
            class="variant-img-wrapper variant-border d-flex h-100 justify-content-center align-items-center"
            matBadgeColor="accent"
            matBadgeSize="small"
            [matBadge]="item.quantity">
            <img class="variant-img"
              [src]="item.variant.image.url"
              [alt]="item.variant.productTitle">
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex h-100 flex-column justify-content-start">
              <p class="fw-bold">{{item.variant.productTitle}}</p>
              <p>{{item.variant.variantTitle}}</p>
            </div>
          </div>
          <div class="col-1 text-end">
            <span>{{item.variant.price}}</span>
          </div>
          <div class="col-1 text-end">
            <span>{{item.quantity}}</span>
          </div>
          <div class="col-2">
            <div class="d-flex justify-content-end fw-bold">
              <span>{{(item.variant.price * item.quantity) | currency: 'USD'}}</span>
            </div>
          </div>
        }
      </div>
      <div class="price-border p-3">
        <div class="d-flex w-100 justify-content-between mt-3 mb-2">
          <span>Subtotal</span>
          <span class="fw-bold">{{order?.subtotalPrice | currency: 'USD'}}</span>
        </div>
        <div class="d-flex w-100 justify-content-between mb-2">
          <div>
            <span>Shipping</span>
          </div>
          <span class="fw-bold">{{order?.totalShipping | currency: 'USD'}}</span>
        </div>
        <div class="d-flex w-100 justify-content-between mb-3">
          <div class="">
            <span>Taxes</span>
          </div>
          <span class="fw-bold">{{order?.totalTax | currency: 'USD'}}</span>
        </div>
      </div>
      <div class="price-border p-3">
        <div class="d-flex w-100 justify-content-between mt-3">
          <span class="sm-title">Total</span>
          <div>
            <span class="tiny-title pe-2">USD</span>
            <span class="big-title fw-bold">{{order?.totalPrice | currency: 'USD'}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobile -->
    <div class="d-block d-lg-none">
      @for (item of order?.items; track item) {
        <div class="row gy-3 mb-4">
          <div class="col-3 col-xl-2">
            <div
              class="variant-img-wrapper variant-border d-flex h-100 justify-content-center align-items-center"
              matBadgeColor="accent"
              matBadgeSize="small"
              [matBadge]="item?.quantity">
              <img class="variant-img" [src]="item?.variant?.image?.url" [alt]="item?.variant?.productTitle">
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex h-100 flex-column justify-content-center">
              <p class="fw-bold">{{item?.variant?.productTitle}}</p>
              <p>{{item?.variant?.variantTitle}}</p>
              <p>{{item?.variant?.price | currency: 'USD'}}</p>
            </div>
          </div>
          <div class="col-2 col-xl-3">
            <div class="d-flex h-100 align-items-center justify-content-end fw-bold">
              <span>{{(item.variant.price * item.quantity) | currency: 'USD'}}</span>
            </div>
          </div>
        </div>
      }
      <div class="price-border">
        <div class="d-flex w-100 justify-content-between mt-3 mb-2">
          <span>Subtotal</span>
          <span class="fw-bold">{{order?.subtotalPrice | currency: 'USD'}}</span>
        </div>
        <div class="d-flex w-100 justify-content-between mb-2">
          <div>
            <span>Shipping</span>
          </div>
          <span class="fw-bold">{{order?.totalShipping | currency: 'USD'}}</span>
        </div>
        <div class="d-flex w-100 justify-content-between mb-3">
          <div class="">
            <span>Estimated taxes</span>
          </div>
          <span class="fw-bold">{{order?.totalTax | currency: 'USD'}}</span>
        </div>
      </div>
      <div class="price-border">
        <div class="d-flex w-100 justify-content-between mt-3">
          <span class="sm-title">Total</span>
          <div>
            <span class="tiny-title pe-2">USD</span>
            <span class="big-title fw-bold">{{order?.totalPrice | currency: 'USD'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="d-flex flex-column col-12 col-lg-6">
        <h3>Billing Address</h3>
        <span>{{order?.billingAddress?.firstName}} {{order?.billingAddress?.lastName}}</span>
        <span>{{order?.billingAddress?.address1}}</span>
        @if (order?.billingAddress?.address2) {
          <span>{{order?.billingAddress?.address2}}</span>
        }
        <span>{{order?.billingAddress?.city}} {{order?.billingAddress?.provinceCode}} {{order?.billingAddress?.zip}}</span>
        <span>{{order?.billingAddress?.country}}</span>
      </div>
      <div class="d-flex flex-column col-12 col-lg-6 mt-3 mt-lg-0">
        <h3>Shipping Address</h3>
        <span>{{order?.shippingAddress?.firstName}} {{order?.shippingAddress?.lastName}}</span>
        <span>{{order?.shippingAddress?.address1}}</span>
        @if (order?.shippingAddress?.address2) {
          <span>{{order?.shippingAddress?.address2}}</span>
        }
        <span>{{order?.shippingAddress?.city}} {{order?.shippingAddress?.provinceCode}} {{order?.shippingAddress?.zip}}</span>
        <span>{{order?.shippingAddress?.country}}</span>
      </div>
    </div>
    <div class="mt-5">
      <a class="link-text d-flex align-items-center h-100 my-5" routerLink="/orders">
        <mat-icon class="me-3">west</mat-icon>
        <span>Go back to my orders</span>
      </a>
    </div>
  </div>
